import { ChapterDetailPage } from "./ChapterDetailPage";
export default ChapterDetailPage;
